<template>
    <svg ref="root" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 177 177">
        <circle
            cx="111"
            cy="88"
            r="80"
            fill="none"
            stroke="#F7F7F7"
            stroke-width="16"
            transform="rotate(-90,100,100)"
            style="display: block"
        />
        <circle
            cx="111"
            cy="88"
            r="80"
            fill="none"
            :stroke="props.fgColor"
            stroke-linecap="round"
            stroke-width="16"
            :stroke-dasharray="stroke"
            transform="rotate(-90,100,100)"
        />
        <text
            text-anchor="middle"
            x="89"
            y="108"
            style="font-size: 48px; line-height: 1;"
            :fill="props.textColor"
        >
            {{ perCent }}%
        </text>
    </svg>
</template>

<script>
import {computed, onMounted, ref} from "vue";

export default {
    name: "counter-circle",
    props: {
        perCent: {
            type: Number,
            required: true
        },
        fgColor: {
            type: String,
            default: "#347DC7"
        },
        textColor: {
            type: String,
            default: "#00233E"
        }
    },
    setup(props) {

        const root = ref();
        const perCent = ref(0);
        const stroke = computed(() => {
            return ( perCent.value *  4.979999988) + ',2000'
        });

        const countUp = () => {
            perCent.value++;
            if (perCent.value < props.perCent) {
                setTimeout(countUp,20);
            }
        }

        const initAction = () => {
            if (
                root.value &&
                (window.innerHeight - 100) > root.value.getBoundingClientRect().top
            ) {
                window.removeEventListener('scroll', initAction);
                countUp();
            }
        }

        window.addEventListener('scroll', initAction);

        onMounted(initAction)

        return {
            root,
            props,
            perCent,
            stroke
        }
    }
}
</script>
